import angular from 'angular';
import {BaseModel} from './BaseModel.js';
import STATE_OPTIONS from './options/STATE_OPTIONS.js';

/**
 * @file 
 * The Contact Service reflects the Jangl Webleads Contact Model from the backend. 
 * https://github.com/revpoint/jangl-webleads/blob/master/jangl_webleads/leads/models.py#L263
 */

export class ContactModel extends BaseModel  {
   
    /**
     * first_name	string	required on POST	First name
     * last_name	string	required on POST	Last name
     * email	    string	required on POST	Email address
     * phone	    string	required on POST	Primary phone number
     * phone2	    string	optional	        Secondary phone number
     * address	    string	required on POST	Primary address
     * address2	    string	optional	        Secondary address
     * city	        string	required on POST	City
     * state	    string	required on POST	State
     * zip_code	    string	required	        Zip code
     * ip_address	-- ignore on the client. it will be set by the server.
     */
    constructor(initializer) {
        const required = ['first_name', 'last_name', 'email', 'phone', 'address', 'city', 'state', 'zip_code'];
        super(required, initializer);
    }
}

/**
 * see: https://github.com/revpoint/jangl-webleads/blob/master/jangl_webleads/leads/models.py#L263
 * see: https://github.com/revpoint/jangl-webleads-capture/blob/master/jangl_webleads_capture/inbound/serializers.py
 */
export class ContactService {

    constructor() { }

    newModel(initializer) {
        return new ContactModel(initializer);
    }

    getStateOptions() {  return  STATE_OPTIONS; }
}



// WEBPACK FOOTER //
// ./app/jangl/ContactService.js